import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'mrs-btn-outline',
    templateUrl: './mrs-btn-outline.component.html',
    styleUrls: ['./mrs-btn-outline.component.scss'],
    imports: [NgIf, MatButtonModule, MatIconModule,]
})
export class MrsBtnOutlineComponent {
  @Input() buttonLabel: string;
  @Input() buttonId: string;
  @Input() isSubmitButton = false;
  @Input() disabled = false;
  @Input() iconName: string;
  @Output() onClick = new EventEmitter<Event>();

}
